import React, { useState, useEffect } from "react";

const ApproverModuleForm = ({
  loading,
  closeModal,
  onSubmit,
  initialValues,
  errors: apiErrors = {}, 
}) => {
  const [formData, setFormData] = useState(() => ({
    ...initialValues,
    is_active: initialValues.is_active === '1' || initialValues.is_active === 1, 
  }));
  const [localErrors, setLocalErrors] = useState({});

  useEffect(() => {
    setFormData({
      ...initialValues,
      is_active: initialValues.is_active === '1' || initialValues.is_active === 1,
    });
  }, [initialValues]);

  useEffect(() => {
    if (apiErrors && Object.keys(apiErrors).length > 0) {
      setLocalErrors(apiErrors);
    }
  }, [apiErrors]);

  const validateField = (name, value) => {
    let error = "";
    if (name === "key") {
      if (!value || value.trim() === "") {
        error = "Module Name is required";
      }
    } else if (name === "display_name") {
      if (!value || value.trim() === "") {
        error = "Display Name is required";
      } else if (value.length > 50) {
        error = "Display Name cannot exceed 50 characters";
      }
    }
    return error;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;
    
    setFormData((prev) => ({
      ...prev,
      [name]: newValue,
    }));

    if (type !== "checkbox") {
      const error = validateField(name, value);
      setLocalErrors((prev) => ({ ...prev, [name]: error }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const keyError = validateField("key", formData.key);
    const displayNameError = validateField("display_name", formData.display_name);

    if (keyError || displayNameError) {
      setLocalErrors({ key: keyError, display_name: displayNameError });
      return;
    }

    const submissionData = new FormData(); 
    submissionData.append("key", formData.key);
    submissionData.append("display_name", formData.display_name);
    submissionData.append("is_active", formData.is_active ? '1' : '0'); 

    onSubmit(submissionData); 
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 font-poppins">
      <div>
        <label htmlFor="key" className="block dark:text-white text-sm font-medium text-gray-700">
          Module Name <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          id="key"
          name="key"
          value={formData.key}
          onChange={handleChange}
          className={`mt-1 dark:bg-black dark:text-white dark:border-gray-700 block w-full border rounded-md p-2 ${
            localErrors.key ? "border-red-500" : "border-gray-300"
          }`}
        />
        {localErrors.key && (
          <p className="text-red-500 text-sm mt-1">{localErrors.key}</p>
        )}
      </div>

      <div>
        <label htmlFor="display_name" className="block dark:text-white text-sm font-medium text-gray-700">
          Display Name <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          id="display_name"
          name="display_name"
          value={formData.display_name}
          onChange={handleChange}
          className={`mt-1 dark:bg-black dark:text-white dark:border-gray-700 block w-full border rounded-md p-2 ${
            localErrors.display_name ? "border-red-500" : "border-gray-300"
          }`}
        />
        {localErrors.display_name && (
          <p className="text-red-500 text-sm mt-1">{localErrors.display_name}</p>
        )}
      </div>

      <div className="flex items-center">
        <input
          type="checkbox"
          id="is_active"
          name="is_active"
          checked={formData.is_active}
          onChange={handleChange}
          className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
        />
        <label htmlFor="is_active" className="ml-2 block text-sm font-medium text-gray-700 dark:text-white">
          Is Active
        </label>
      </div>

      <div className="flex justify-end items-center gap-2">
        <button
          type="button"
          onClick={closeModal}
          className="px-6 py-2 text-black hover:bg-gray-200 dark:hover:bg-gray-900 dark:bg-black dark:text-white dark:focus:outline-none border border-gray-300 rounded-md"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="flex items-center gap-2 px-8 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          disabled={loading || Object.values(localErrors).some(err => err)}
        >
          {initialValues.id ? "Update" : "Add"}
          {loading && (
            <svg
              className="animate-spin h-5 w-5 ml-2 text-white"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
              ></path>
            </svg>
          )}
        </button>
      </div>
    </form>
  );
};

export default ApproverModuleForm;
